// CID Agent PWA API layer
// Module: Memos from HQ — memos addressed to the signed-in agent. The server
// decides which memos reach them (HQ's chosen branches / ranks, resolved live).
import client from './client';

/** GET /api/agent/memos/pending — live pop-up memos not yet confirmed, oldest first: { popups }. */
export const getPending = () => client.get('/api/agent/memos/pending');

/** GET /api/agent/memos/unread-count — { unread }: live memos not yet read (the More tile's badge). */
export const getUnreadCount = () => client.get('/api/agent/memos/unread-count');

/** GET /api/agent/memos?page=&limit= — every memo the agent has had: { memos, unread, pagination }. */
export const listMemos = (params = {}) => client.get('/api/agent/memos', { params });

/** GET /api/agent/memos/:id — one memo, with read_at. */
export const getMemo = (id) => client.get(`/api/agent/memos/${id}`);

/** POST /api/agent/memos/shown — the app put these memos on screen. */
export const markShown = (ids) => client.post('/api/agent/memos/shown', { ids });

/** POST /api/agent/memos/:id/read — "I have read this" (or a notification-only memo opened). */
export const markRead = (id) => client.post(`/api/agent/memos/${id}/read`);
